module.exports = __webpack_public_path__ + "static/media/iconTextbookActive.ba6e95bf.svg";